import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="recaptcha-v2"
export default class extends Controller {
  static values = { 
    siteKey: String,
    enabled: Boolean 
  }

  connect() {
    if (!this.enabledValue) {
      return
    }

    this.loadRecaptcha()
  }

  disconnect() {
    // Clean up when navigating away
    this.cleanupRecaptcha()
  }

  loadRecaptcha() {
    // Check if reCAPTCHA is already loaded
    if (window.grecaptcha && window.grecaptcha.render) {
      this.renderRecaptcha()
      return
    }

    // Load reCAPTCHA script if not already loaded
    if (!document.querySelector('script[src*="recaptcha/api.js"]')) {
      const script = document.createElement('script')
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit'
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }

    // Set up global callback
    window.onRecaptchaLoad = () => {
      this.renderRecaptcha()
    }
  }

  renderRecaptcha() {
    const container = this.element.querySelector('.g-recaptcha')
    if (container && !container.hasChildNodes()) {
      try {
        window.grecaptcha.render(container, {
          sitekey: this.siteKeyValue,
          theme: 'light'
        })
      } catch (error) {
        console.error('reCAPTCHA render error:', error)
      }
    }
  }

  cleanupRecaptcha() {
    const container = this.element.querySelector('.g-recaptcha')
    if (container) {
      container.innerHTML = ''
    }
  }
}